import { render } from "./QueOption2.vue?vue&type=template&id=00e6f4a4&scoped=true"
import script from "./QueOption2.vue?vue&type=script&lang=js"
export * from "./QueOption2.vue?vue&type=script&lang=js"

import "./QueOption2.vue?vue&type=style&index=0&id=00e6f4a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e6f4a4"]])

export default __exports__